// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scrollbar[data-v-c18ec53e] {\n  width: 100%;\n  height: calc(100vh - 68px);\n  overflow: auto;\n}", ""]);
// Exports
module.exports = exports;
